module.exports = __webpack_public_path__ + "img/faq-impostor-2.0f9c35a0.png";